// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__sPHYF","logo":"style_logo__ol8V5"};